import { render, staticRenderFns } from "./ResumoBoletimSanitario.vue?vue&type=template&id=178e1272&scoped=true&"
import script from "./ResumoBoletimSanitario.vue?vue&type=script&lang=js&"
export * from "./ResumoBoletimSanitario.vue?vue&type=script&lang=js&"
import style0 from "./ResumoBoletimSanitario.vue?vue&type=style&index=0&id=178e1272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178e1272",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
